module.exports = __webpack_public_path__ + "img/thumbnail_ScimitarHornedOryx_m_normal.f26f0c29.png";